"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.escapeRegexSpecialChars = void 0;
/**
 * Escape any regex special characters in a string so that the escaped string can be used in a regex
 * @param string {string} : 'Dr. Jart+'
 * @returns {string} : 'Dr\. Jart\+'
 */

var escapeRegexSpecialChars = exports.escapeRegexSpecialChars = function escapeRegexSpecialChars(string) {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}; // $& means the whole matched string